import { createSlice } from '@reduxjs/toolkit';
import { IS_LOGIN } from 'config.js';


const initialState = {
  isLogin: IS_LOGIN,
  authToken: null,
  applicationToken: null,
  //currentUser: {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signIn(state, action){
      const { user, applicationToken, authToken } = action.payload
      //state.currentUser = user;
      state.applicationToken = applicationToken;
      state.authToken = authToken
      state.isLogin = true;
    },
    signOut(state, action){
      //state.currentUser = null;
      state.applicationToken = null;
      state.authToken = null;
      state.isLogin = false;
    },
    setCurrentUser(state, action) {
      /*
      if (action.payload && action.payload.hasOwnProperty('applicationToken')) {
        const { user, applicationToken, authToken } = action.payload
        if (applicationToken) {
          state.currentUser = user;
          state.applicationToken = applicationToken || null;
          state.authToken = authToken || null
          state.isLogin = true;
        }
      } else {
        state.currentUser = null;
        state.isLogin = false;
        state.applicationToken = null;
      }
      */
    },
    updateGid(state, action) {
      if (action.payload) {
        state.authToken = action.payload || null
      }
    },
    /*
    updateCurrentUser(state, action) {
      if (action.payload) {
        state.currentUser = action.payload;
      }
    }
    */
  },
});

export const { setCurrentUser, signIn, signOut } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
